import Buttons from '@klv/molecules/buttons';
import { generateClassName } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';
import { LIGHT_BACKGROUNDS } from '@klv/shared/utils/variables';

import * as styles from './styles/sectionHeader.module.scss';
import type { ISectionHeader } from './types';
import type { TVariantOptions } from '@klv/atoms/button/types';

export const SectionHeader = ({
  alignment = 'left',
  backgroundColor = 'charcoal',
  buttonPlacement,
  buttons,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  eyebrow,
  firstButtonStyle,
  fontColor = 'defaultColor',
  headline,
  headlineStyle = 'h1',
  headlineTag: THeadlineTag = 'div',
  secondButtonStyle,
  showBottomBorder,
  showTopBorder,
  subtext,
  subtextFontStyle = 'p',
  subtextTag: TSubtextTag = 'p',
  useInset,
}: ISectionHeader) => {
  const buttonColor = LIGHT_BACKGROUNDS.includes(backgroundColor) 
    ? 'dark' 
    : 'light';
  const alignmentClass = alignment === 'center' ? styles.centeredContent : '';
  const insetClass = useInset ? styles.inset : '';

  const renderButtons = (placement: string) => {
    if (!buttons) return null;
    const containerClass =
      placement === 'inlineWithHeadline' ? styles.buttonContainerInline : styles.buttonContainer;
    const firstButton: TVariantOptions = firstButtonStyle as TVariantOptions || 'secondary';
    const secondButton: TVariantOptions = secondButtonStyle as TVariantOptions  || 'tertiary';

    return (
      <div className={containerClass}>
        <Buttons buttons={buttons} buttonColor={buttonColor} variants={[firstButton, secondButton]}/>
      </div>
    );
  };

  return (
    <Wrapper customPadding={customPadding} backgroundColor={backgroundColor}>
      <div data-organism="Section Header" className={generateClassName(['grid', styles.styledGrid])}>
        <div className={generateClassName([styles.sectionHeader, alignmentClass, insetClass, (!buttons || buttonPlacement === 'belowHeadline') && styles.oneColumn])}>
          {showTopBorder && <div className={styles.topBorder} />}
          {eyebrow && <p className={`eyebrow ${styles.eyebrow} ${fontColor ? styles[fontColor] : ''}`}>{eyebrow}</p>}

          {headline && (
            <THeadlineTag className={generateClassName([styles.headline, fontColor && styles[fontColor], headlineStyle])} dangerouslySetInnerHTML={{ __html: headline }}/>
          )}

          { renderButtons(buttonPlacement || 'belowHeadline') }

          {subtext && <TSubtextTag className={generateClassName([styles.subtext, fontColor && styles[fontColor], subtextFontStyle])} dangerouslySetInnerHTML={{ __html: subtext }} />}

          {showBottomBorder && <div className={styles.bottomBorder} />}
        </div>
      </div>
    </Wrapper>
  );
};
